export default __webpack_public_path__ + "static/media/rock.cbe1ed87.svg";